const showModule = (warranty: string | undefined | null): boolean | undefined => !!warranty;

export default showModule;
